import { fg } from '@atlassian/jira-feature-gating';

const JiraTimelineHierarchyBoardFilterRelayProvider = {
	get(): boolean {
		return fg('jira_timeline_hierarchy_board_filter');
	},
};

export default JiraTimelineHierarchyBoardFilterRelayProvider;
